// extracted by mini-css-extract-plugin
export default {"loader-container":"SplashScreen_loader-container__vSwMo","click-finger":"SplashScreen_click-finger__sNqq1","click-rounds":"SplashScreen_click-rounds__3PTSA"};